import { Dialog, Table } from "../../../../../layout";
import { IconButton, Tooltip } from "@mui/material";
import { SellOutlined, VisibilityRounded } from "@mui/icons-material";
import { useContext, useEffect, useState } from "react";
import { Select } from "../../../../../controls";
import { AppContext } from "../../../../../App";
import { action, API, controller } from "../../../../../api/api";
import ViewQuoteSale from "../ViewQuote/ViewQuote";
import CustomerWidget from "./CustomerWidget";
import UserWidget from "./UserWidget";
import QuoteStatus from "./QuoteStatus";
import {
  formatDate,
  lsSave,
  useFormatPrice,
} from "../../../../../hooks/Method";
import { useNavigate } from "react-router-dom";

const Quotes = () => {
  const formatPrice = useFormatPrice();
  const navigate = useNavigate();
  const { setLoader } = useContext(AppContext);
  const [viewSale, setViewSale] = useState(false);
  const [status, setStatus] = useState(1);
  const [quotes, setQuotes] = useState([]);
  const [viewData, setViewData] = useState({});

  useEffect(() => {
    setLoader(true);
    if (status) {
      API(controller.QuoteSale + action.GetAllByStatus).getById(
        status,
        (res) => {
          if (res && res.status === 200) {
            setQuotes([...res.result]);
          }
          setLoader(false);
        }
      );
    } else {
      API(controller.QuoteSale + action.GetAllByOrg).get((res) => {
        if (res && res.status === 200) {
          setQuotes([...res.result]);
        }
        setLoader(false);
      });
    }

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  const handleView = (data) => {
    setViewData({ ...data });
    setViewSale(!viewSale);
  };

  const handleFltr = (e) => {
    setStatus(e.target.value);
  };

  const handleContinuSale = (val) => {
    lsSave("quoteSaleId", val.id);
    navigate("/pos");
  };

  const ActionComp = (val) => (
    <div className="bs-secondary br-8 w-fit">
      <Tooltip title="View Details">
        <IconButton
          onClick={() => handleView(val)}
          size="small"
          color="primary"
          className="mr-5 p-5"
        >
          <VisibilityRounded className="fs-18 m-2" />
        </IconButton>
      </Tooltip>
      <Tooltip onClick={() => handleContinuSale(val)} title="Continue Sale">
        <IconButton size="small" color="primary" className="p-5">
          <SellOutlined className="fs-18 m-2" />
        </IconButton>
      </Tooltip>
    </div>
  );

  const HeaderComp = () => (
    <Select
      variant="outlined"
      size="small"
      fullWidth
      value={status}
      onChange={handleFltr}
      options={[
        { id: 0, label: "All Quotes" },
        { id: 1, label: "Open" },
        { id: 2, label: "Completed" },
        { id: 3, label: "Archived" },
      ]}
    />
  );

  return (
    <>
      <div className="mb-10">
        <span className="border-left fs-22 gray-color tx-upp">Quotes</span>
      </div>

      <Table
        ActionComp={ActionComp}
        HeaderComp={HeaderComp}
        tblHead={[
          { id: "quote", label: "Quote" },
          { id: "cstmr", label: "Customer" },
          { id: "servedBy", label: "Served by	" },
          { id: "note", label: "Note" },
          { id: "quoteTotal", label: "Quote Total" },
          { id: "statusChip", label: "Status" },
          { id: "actions", label: "Actions" },
        ]}
        tblData={quotes.map((item) => {
          var customer = item.customer ? item.customer : null;
          var servedUser = item.servedUser ? item.servedUser : null;
          return {
            ...item,
            quoteTotal: (
              <span className="text-[18px] font-medium">
                {formatPrice(item.totalPay)}
              </span>
            ),
            quote: (
              <div className="d-grid">
                <span className="">{item.id}</span>
                <span className="fs-12">{formatDate(item.createDate)}</span>
              </div>
            ),
            statusChip: <QuoteStatus status={item.status} />,
            cstmr: <CustomerWidget value={customer} />,
            servedBy: (
              <UserWidget {...{ value: servedUser, outlet: item.outlet }} />
            ),
          };
        })}
      />

      {viewSale && (
        <Dialog show={viewSale} onClose={false} maxWidth="md">
          <ViewQuoteSale
            {...{
              setShowForm: setViewSale,
              handleView,
              id: viewData.id,
              setQuotes,
              handleContinuSale,
            }}
          />
        </Dialog>
      )}
    </>
  );
};

export default Quotes;
